import React from 'react';
import Header from './layout/Header/Header';
import Main from './layout/Main/Main';


const propTypes = {
  children: React.PropTypes.object
};

const App = props => (
  <div className='App'>
    <div className='bg-image js-bg-image'></div>
    <Header/>
    <Main>
      {props.children}
    </Main>
  </div>
);

App.propTypes = propTypes;

export default App;



// WEBPACK FOOTER //
// ./src/App.js